<template>
	<div class="categ_info" v-if="obj_to_null(this.categ)">
		<info_field f_uniq="ct"
					f_type="title"
					@update_categ="change_atr"
					:f_title="__t('NAME')"
					:is_disabled="is_disabled"
					:f_val="cur_categ.title">

		</info_field>
		<info_field f_uniq="cid" :f_title="__t('UNIQ_GO_CODE')"  :f_val="cur_categ.id.toString()"></info_field>
		<info_field  f_uniq="cuid" :f_title="__t('UNIQ_PROV_CODE')" :f_val="cur_categ.uniq_id"></info_field>
		<info_field :f_title='__t("LOAD_FROM")' f_icon="fa-sync" :f_val="prov_name"></info_field>

        <div class="form-group mt-2">
            <label class="form-label" for="description">
                {{ __t('INTRO_CATEG') }}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                </div>
                <textarea id="description" class="form-control" v-model="cur_categ.introcontent"></textarea>
            </div>
        </div>




		<div class="form-group">
			<label class="form-label" for="name-f">{{__t("DATE_CREATE")}}</label>
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text text-success">
						<i class="fal fa-calendar-edit fs-xl"></i>
					</span>
				</div>
				<input type="text" class="form-control" id="name-f" disabled v-model="cur_categ.added">
				<input type="text" class="form-control" id="name-l" disabled v-model="cur_categ.updateAt">
			</div>
		</div>
	</div>
</template>

<script>
import Info_field from "../../../../sys/info_field";
import yes_no from "../../../../sys/radio/yes_no.vue";
import Product_labels from "../../../products/product/extra_components/product_labels.vue";

export default {
	name: "categ_info",
	components: {Product_labels, yes_no, Info_field},
	props : {
		categ : {
			type : Object
		}
	},
	data() {
		return {
			cur_categ : this.categ,
			is_load: false,
            category_modes : [
                {text: 'DEFAULT',  value: 'default'},
                {text: 'TAG_MODE', value: 'tag'},
            ],
            allowed_labels: [],
            label_groups: {},
		}
	},

    created() {

    },

	methods :  {
		change_atr(atr_name,atr_val) {
			if(this.categ.hasOwnProperty(atr_name)) {
				this.categ[atr_name] = atr_val;
			}
		},
        setCategMode(val) {
            this.change_atr('category_mode',val)
        },


	},
	computed : {
		is_disabled () {
			return this.cur_categ.id > 0 && parseInt(this.cur_categ.provider_id) != 8;
		},

        prov_name() {
		    if(this.cur_categ.hasOwnProperty("provider")) {
		        return this.cur_categ.provider.name + " <-- " + this.cur_categ.provider.direction;
            }
        }
	},
}
</script>

<style scoped>

</style>
